import React from 'react';
import { FlexibleHomepageLoader } from '@helpcenter/flexible-homepage-loader';
import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ViewCustomPage = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: 'async-view-custom-page' */ './view-custom-page'),
	),
	LoadingSkeleton: () => <FlexibleHomepageLoader />,
});

export const ViewCustomPageWithAiAgent = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: 'async-view-custom-page-with-ai-agent' */ './csm-variants'),
	),
	LoadingSkeleton: () => <FlexibleHomepageLoader />,
});
